export default __webpack_public_path__ + "static/media/Broccoli.af17a85c.mp4";